import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ChipCodeForm, ChipModel } from '@app/models/chip.model';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Button } from "primeng/button";
import { ChipService } from '@app/pages/chip-registration/services/chip.service';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputMaskModule } from 'primeng/inputmask';
import { Message } from "primeng/message";
import { TranslatePipe } from '@ngx-translate/core';
import { isCode15 } from '@app/models/chip-code.type';

@Component({
    selector: 'app-chip-search',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    FloatLabelModule,
    TranslatePipe,
    Message,
    Button,
    InputMaskModule
],
    templateUrl: './chip-search.component.html',
    styleUrl: './chip-search.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipSearchComponent {
    readonly formGroup = input.required<FormGroup<ChipCodeForm>>();
    readonly isRegistration = input<boolean>(true);

    readonly isChipReadyForRegistration = output<boolean>();

    isChipAlreadyUsed = false;

    private chipService = inject(ChipService);

    searchButtonClicked(): void {
        this.isChipAlreadyUsed = false;
        const code = this.formGroup().value.code;
        if (code && isCode15(code)) {
            this.chipService.getChipSearchByCode(code).subscribe((chips: ChipModel[]) => {
                this.isChipReadyForRegistration.emit(chips.length === 0);
                this.isChipAlreadyUsed = chips.length > 0;
            });
        }
    }
}
